import React, { useState } from 'react';
import { Card, CheckboxInput, Icon } from '@nearst/ui';
import { Protect } from '@clerk/clerk-react';

import styles from './MultiItemBasketToggle.module.scss';

import { useShop } from '@services/ShopProvider';
import { updateChannel } from '@services/channels';

export const MultiItemBasketToggle = ({ channelId, channelData, description }) => {
	const { shop } = useShop();
	const [multiItemBasket, setMultiItemBasket] = useState(channelData?.config?.multiItemBasket ?? false);

	return (
		<Card title="Basket settings">
			<Protect
				permission="org:channels:manage"
				fallback={
					<div className={styles.disabledState}>
						<Icon>lock</Icon>
						<p>You don't have permission to update basket settings</p>
					</div>
				}
			>
				<div className={styles.toggle}>
					<CheckboxInput
						label="Multi-item baskets"
						checked={multiItemBasket}
						onClick={async (e) => {
							setMultiItemBasket(e.target.checked);
							await updateChannel(shop.id, channelId, { multiItemBasket: e.target.checked });
						}}
					/>
					<p className={styles.description}>{description}</p>
				</div>
			</Protect>
		</Card>
	);
};
